import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './views/Login';
import LoginAdmin from './views/LoginAdmin';
import PaymentListUser from './views/PaymentListUser';
import SoInvoice from './views/SoInvoice';
import PaymentTransactionResult from './views/PaymentTransactionResult';
import ProtectedRoutes from './contexts/ProtectedRoutes';
import { AuthLayout, DashboardLayout } from './layouts';
import AuthProvider from './contexts/AuthContext';
import NotFound from './components/NotFound/NotFound';
import SettingUser from './views/SettingUser';
import Contact from './views/Contact';
import UserManagement from './views/UserManagement';
import PaymentListMerchant from './views/PaymentListMerchant';
import EmailManagements from './views/EmailManagement';
import UploadMerchant from './views/UploadMerchant';
import InvoiceList from './views/InvoiceList';
import ResponseRegisterPage from './views/ResponseRegisterPage';
import { checkAccessRights } from './utils/functions/accessRight';
import { ROLES } from './utils/constants';
import Dashboard from './views/Dashboard';
import ConfigListMerchant from './views/ConfigListMerchant';
import CompanyList from './views/CompanyList';
import CompanyManagement from './views/CompanyManagement';
import Register from './views/Register';
// import AuthCallback from './views/AuthCallback';

function App() {
  const renderRouterFromAccessibleRole = () => {
    if (checkAccessRights(ROLES.USER_ROLE)) {
      console.log('USER LAYOUT');
      return (
        <Route
          path="/"
          element={<DashboardLayout checkAccessRights={checkAccessRights} />}
        >
          <Route index element={<SoInvoice />} />
          <Route path="/show-invoice" element={<SoInvoice />} />
          <Route path="/payment-list-user" element={<PaymentListUser />} />
          <Route path="/setting" element={<SettingUser />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      );
    }
    if (
      checkAccessRights(ROLES.ADMIN_ROLE) ||
      checkAccessRights(ROLES.SUPER_ADMIN_ROLE)
    ) {
      /* ADMIN LAYOUT */
      console.log('ADMIN LAYOUT');
      return (
        <Route
          path="/"
          element={<DashboardLayout checkAccessRights={checkAccessRights} />}
        >
          <Route index element={<UploadMerchant />} />
          <Route path="/upload-admin" element={<UploadMerchant />} />
          <Route path="/invoice-list" element={<InvoiceList />} />
          <Route path="/payment-list-admin" element={<PaymentListMerchant />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/email-management" element={<EmailManagements />} />
          <Route path="/Dashboard-display" element={<Dashboard />} />
          <Route path="/config-list" element={<ConfigListMerchant />} />
          <Route path="/company-list" element={<CompanyList />} />
          <Route path="/company-management" element={<CompanyManagement />} />
        </Route>
      );
    }
    return <Route path="/" element={<div />} />;
  };

  return (
    <AuthProvider>
      <Routes>
        {/* <Route path="/login" element={<AuthLayout />}> */}
        <Route path="/:merchantPath" element={<AuthLayout />}>
          <Route index element={<Login />} />
        </Route>
        <Route path="/register/:merchantPath" element={<AuthLayout />}>
          <Route index element={<Register />} />
        </Route>
        <Route path="/login-admin" element={<AuthLayout />}>
          <Route index element={<LoginAdmin />} />
        </Route>
        <Route element={<ProtectedRoutes />}>
          {renderRouterFromAccessibleRole()}
        </Route>
        <Route path="/payment-transaction-result/:token">
          <Route index element={<PaymentTransactionResult />} />
        </Route>
        {/* <Route path="/auth" element={<AuthCallback />} /> */}
        <Route path="*" element={<NotFound />} />
        <Route path="/response-register" element={<ResponseRegisterPage />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
